import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export const MySwal = withReactContent(Swal);

export function closeAlert() {
  MySwal.close();
}
export function errorAlert(message?: string) {
  MySwal.fire({
    icon: "error",
    title: "", // You can add a title if needed
    html: `<small>${message}</small>`, // Display the message
    timer: 4000, // Duration for which the alert will be visible
    timerProgressBar: false, // Optional: show a progress bar
    showCancelButton: false, // Hide the cancel button
    showConfirmButton: false, // Hide the confirm button
    showCloseButton: false, // Hide the close button
  });
}
export function successAlert(message?: string) {
  MySwal.fire({
    icon: "success",
    showConfirmButton: false,
    timer: 60000, // Auto-close after 5 seconds
    html: `<small style="font-size:14px">${message}</small>`,
  });
}
export function confirmAlert(message: string) {
  return MySwal.fire({
    html: `<small style="font-size:14px">${message}</small>`,
    icon: "info",
    showCancelButton: true,
    confirmButtonColor: "#0083ff !important",
    cancelButtonColor: "red",
    confirmButtonText: "Yes",
    cancelButtonText: "No",
  });
}
